<template>
  <editor
    api-key="9e86e9z0v1z8b8x78wypdpc0cpimqkeux1950hb6n6paecfg"
    v-model="localHighlights"
    :init="{
      schema: 'html5',
      menubar: false, // Enable menubar for better UI
      branding: false,
      plugins: [
        'advlist autolink autosave autoresize link image lists charmap hr anchor',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking',
        'table template colorpicker paste textcolor importcss textpattern spellchecker',
        'fontsizeselect',
        'forecolor',
        'backcolor',
        'code',
        'image' // Ensure image plugin is included
      ],
      toolbar: [
        'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright | blockquote | formatselect',
        'bullist numlist | outdent indent | hr | link unlink image code | inserttime',
        'table | fontsizeselect | forecolor | backcolor'
      ],
      fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px 48pt 72px',
      content_style: 'body { font-size: 14px; }',
      automatic_uploads: true,
      images_upload_url: 'http://localhost:3000/upload', // Your backend endpoint
      images_upload_base_path: '/uploads',
      file_picker_types: 'image',
      images_upload_handler: imageUpload
      
    }"
  ></editor>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import API from "@/api";

export default {
  name: "TinymceEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  components: {
    editor: Editor
  },
  data() {
    return {
      localHighlights: this.value
    };
  },
  watch: {
    // Sync parent updates to localHighlights
    value(newVal) {
      if (newVal !== this.localHighlights) {
        this.localHighlights = newVal;
      }
    },

    // Emit updates back to parent
    localHighlights(newVal) {
      this.$emit("input", newVal);
    }
  },
  methods:{
    async imageUpload(blobInfo, success, failure) {
      try {
        this.uploadLoading = true;
        debugger
        const formData = new FormData();

        formData.append('upload', blobInfo.blob(), blobInfo.filename());

        const { data } = await API.vdpManager.uploadCoverImage(formData);
        console.log("data",data)
        if (data.uploaded) {
            success(data.url);
          } else {
            failure('Failed to upload image');
          }
      } catch (error) {
        console.log(error)
      } finally {
       
      }
    },
  }
};
</script>
